<mat-card>
    <mat-card-header class="titreFrm">
      <mat-card-title>MATI&Egrave;RE</mat-card-title>
    </mat-card-header>
    <mat-card-content class="border">
      <div *ngIf="exist;else attente"></div>
      <ng-template #attente>
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </ng-template>
      <mat-card>
        <mat-card-content>
            <div class="displayFlex">
                <mat-form-field     appearance="outline"  >
                  <mat-label>Matière</mat-label>
                    <input matInput name="matiere" #matiere="ngModel" [(ngModel)]="parametre.DiverSys_Titre"
                    placeholder="Matière" >
                </mat-form-field>
                <div *ngIf="showBtnListeMatiere">
                    <button [disabled]="!exist"  (click)="enregister()" mat-raised-button class="colorGreen"><mat-icon>save</mat-icon>Enregistrer</button>
                    
                </div>
            </div>
            <div *ngIf="!showBtnListeMatiere" class="displayFlex">
              <div>
                  <button (click)="close()" mat-raised-button class="colorRed"><mat-icon>close</mat-icon>Fermer</button>
              </div>
              <div>
                <button [disabled]="!exist"  (click)="enregister()" mat-raised-button class="colorGreen"><mat-icon>save</mat-icon>Enregistrer</button>
              </div>
            </div>
        </mat-card-content>
      </mat-card>
        